import { render, staticRenderFns } from "./addConfigDialog.vue?vue&type=template&id=4abfcfb8&"
import script from "./addConfigDialog.vue?vue&type=script&lang=js&"
export * from "./addConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./addConfigDialog.vue?vue&type=style&index=0&id=4abfcfb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports